import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import reportWebVitals from "./reportWebVitals";
import ThemeContext from "./context/ThemeContext";
import { PlansContextProvider } from "./context/PlanContext";
import { PhoneNumberContextProvider } from "./context/PhoneNumbersContext";
import { AuthContextProvider } from "./context/AuthContext";
import { SubscribersContextProvider } from "./context/SubscriberContext";
import "./App.css";
import { AdminContextProvider } from "./context/AdminsContext";
import { LoadingProvider } from "./context/LoadingContext";
import axios from "axios";

// --- Global API Config ---
const baseUrl = process.env.REACT_APP_API_URL || '';
axios.defaults.baseURL = baseUrl;
axios.defaults.withCredentials = true;

const originalFetch = window.fetch;
window.fetch = async function (...args) {
  let [resource, config] = args;
  if (typeof resource === 'string' && resource.startsWith('/api/')) {
    resource = baseUrl + resource;
  }
  
  if (config) {
    config.credentials = 'include';
  } else {
    config = { credentials: 'include' };
  }
  
  return originalFetch(resource, config);
};
// -------------------------

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeContext>
          <LoadingProvider>
            <AuthContextProvider>
              <SubscribersContextProvider>
                <PlansContextProvider>
                  <PhoneNumberContextProvider>
                    <AdminContextProvider>
                      <App />
                    </AdminContextProvider>
                  </PhoneNumberContextProvider>
                </PlansContextProvider>
              </SubscribersContextProvider>
            </AuthContextProvider>
          </LoadingProvider>
        </ThemeContext>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);
reportWebVitals();
